/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RenderTableColumn = {
    id: string;
    name: string;
    kind: RenderTableColumn.kind;
    expression?: (string | null);
    return_type?: (string | null);
};

export namespace RenderTableColumn {

    export enum kind {
        METADATA = 'metadata',
        ATTRIBUTE = 'attribute',
        GROUP = 'group',
    }


}

